import { getTenantName, Tenant } from './../../models/tenant.model';
import { ReportsService } from './../../services/reports.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Report, Dictum } from './../../models/report.model';
import { Broker } from './../../models/broker.model';
import { ErrorResponse } from './../../models/error.model';
import { PageEvent } from '@angular/material/paginator';
import { UtilsService } from 'src/app/services/utils.service';
import { DataTableColumn, PaginatorStatus, SortConfiguration, MenuButton } from './../generics/data-table/data-table.component';
import { Component, OnInit } from '@angular/core';
import { CustomTableFilter } from '../generics/table-filter/table-filter.component';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectOption } from 'src/app/models/select-option.model';
import { Executions } from 'src/app/models/executions.model';


@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    // Multititular: consulta exclusiva de personas físicas, una o más como una única unidad económica
    personasFormArray = new UntypedFormArray([]);

    get personasControls() {
        return this.personasFormArray.controls as UntypedFormGroup[];
    }

    columns: DataTableColumn[] = [
        { name: 'Apellido y Nombre', prop: 'apeNom', parseValue: (value: string) => value ?? '-' },
        { name: 'Fecha', prop: 'fechaCreacion', sortable: true, type: 'datetime' },
        { name: 'Usuario solicitante', prop: 'emailSolicitante', type: 'text' },
        { name: 'DNI', prop: 'personas', parseValue: (tenants: Tenant[]) => tenants.map(tenant => tenant.tipoPersona === 'FISICA' ? tenant.personaFisica.dni : this.utilsService.parseByType(tenant.personaJuridica.cuit, 'cuit')).join('<br>') },
        { name: 'Dictamen', prop: 'dictamen', sortable: true },
        { name: 'Motivo de rechazo', prop: 'mensajeOutput' },
    ];

    menuButtons: MenuButton<Report>[] = [
        { label: 'Ver detalles', action: report => this.router.navigate([report.id], { relativeTo: this.route }) }
    ];

    sortConfiguration?: SortConfiguration;

    reports: Report[];

    filters: CustomTableFilter[] = [
        { key: 'fecha-desde', description: 'Fecha desde', type: 'DATE' },
        { key: 'fecha-hasta', description: 'Fecha hasta', type: 'DATE' },
        { key: 'persona-apellido', description: 'Apellido y Nombre del inquilino', type: 'STRING' },
        { key: 'persona-dni', description: 'DNI del inquilino', type: 'STRING' },
    ];
    filterValues: any = {};

    constructor(
        private reportsService: ReportsService,
        public utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute,

    ) {}

    ngOnInit(): void {
        this.getReports();
        this.addPersona();
    }

    getReports() {
        this.reportsService.getReports(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, this.sortConfiguration ? [this.sortConfiguration] : [], this.filterValues)
        .subscribe(response => {
            this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
            this.reports = response.body;
            console.log(this.reports);
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener informes', error.error?.descripcion));
    }

    updateReports(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getReports();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getReports();
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getReports();
    }

    addPersona() {
        const FG = new UntypedFormGroup({
            dni: new UntypedFormControl(undefined, [Validators.required]),
            sexo: new UntypedFormControl(null, [Validators.required]),
        });
        this.personasFormArray.push(FG);
    }

    removePersona(i: number) {
        this.personasFormArray.removeAt(i);
    }

    getScoring() {
        this.personasFormArray.markAllAsTouched();

        if (this.personasFormArray.invalid) {
            return;
        }

        const personas: Partial<Tenant>[] = this.personasFormArray.getRawValue().map((persona: { dni: string; sexo: string }) => ({
            email: null,
            tipoPersona: 'FISICA',
            personaFisica: {
                dni: persona.dni,
                sexo: persona.sexo,
                nombre: null,
                apellido: null,
                email: null,
                celular: null,
                fechaNacimiento: null,
                direccion: null,
                representante: null,
            }
        }));

        this.reportsService.generateReport(personas).subscribe({
            next: response => {
                this.reports.push(response);
                this.router.navigate(['informes', response.id])
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener scorings', error.error?.descripcion)
        })
    }

    setSexo(i: number, value: string) {
        const control = this.personasControls[i].controls.sexo;
        control.setValue(value);
        control.markAsTouched();
    }

    onDniKeyPress(event: KeyboardEvent): boolean {
        return /[0-9]/.test(event.key);
    }

}
